// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__ABIk2Ts4Ou{min-width:220px}`, "",{"version":3,"sources":["webpack://./src/assets/fable/queueSelect/queueSelect.module.scss"],"names":[],"mappings":"AAAA,kBACE,eAAA","sourcesContent":[".root {\n  min-width: 220px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__ABIk2Ts4Ou`
};
export default ___CSS_LOADER_EXPORT___;
